import { render } from "./dataLogado.vue?vue&type=template&id=4da0e878&scoped=true"
const script = {}

import "./dataLogado.vue?vue&type=style&index=0&id=4da0e878&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da0e878"]])

export default __exports__